import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import './styles/hybrid-theme.css';

if (import.meta.env.DEV) console.log('CruvzMail v2.1.0');

if (typeof window !== 'undefined') {
  // Force-disable stale cached app shells/chunks so hotfix deployments take effect immediately.
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister().catch(() => undefined);
      });
    }).catch(() => undefined);
  }

  if ('caches' in window) {
    caches.keys().then((keys) => Promise.all(keys.map((key) => caches.delete(key)))).catch(() => undefined);
  }

  // One-time migration: drop persisted compose tab bodies that pre-date the
  // signature-image data-signature normalization so they get re-built on next
  // open with the correctly-tagged HTML. Guard with a flag so we only do it once.
  try {
    const MIGRATION_KEY = '__cruvz_sig_migration_v2_applied';
    if (!localStorage.getItem(MIGRATION_KEY)) {
      const tabsRaw = localStorage.getItem('zmail-compose-tabs');
      if (tabsRaw && tabsRaw.indexOf('<img') !== -1 && tabsRaw.indexOf('data-signature') === -1) {
        localStorage.removeItem('zmail-compose-tabs');
      }
      localStorage.setItem(MIGRATION_KEY, '1');
    }
  } catch {
    /* ignore */
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
// Build 1767763440
